import apiClient from "./apiClient";

const API_URL = process.env.REACT_APP_API_URL;

// Authentication API
export const loginUser = async ({ email, password }) => {
	const response = await apiClient.post(`${API_URL}/auth/login`, {
		email,
		password,
	});
	return response.data;
};

export const registerUser = async ({
	name,
	surname,
	email,
	password,
	currency,
}) => {
	const response = await apiClient.post(`${API_URL}/auth/register`, {
		name,
		surname,
		email,
		password,
		userCurrency: currency,
	});

	setTimeout(() => {
		window.location.href = "/login";
	}, 300);
	return response.data;
};

// User API
export const updateUserSettings = async (payload) => {
	const response = await apiClient.patch(`${API_URL}/user`, payload);
	return response.data;
};

export const getUserDetails = async () => {
	const response = await apiClient.get(`${API_URL}/user/me`);
	return response.data;
};
export const changeUserPassword = async ({
	currentPassword,
	newPassword,
	confirmPassword,
}) => {
	const response = await apiClient.post(`${API_URL}/user/change-password`, {
		currentPassword,
		newPassword,
		confirmPassword,
	});
	return response.data;
};

export const verifyEmail = async (token) => {
	try {
		const response = await apiClient.get(
			`${API_URL}/auth/verify-email?token=${token}`,
		);
		return response.data;
	} catch (err) {
		console.error(err);
	}
};

export const resendVerificationEmail = async (email, lang = "en") => {
	try {
		const response = await apiClient.post(`/auth/resend-verification`, {
			email,
			lang,
		});
		return response.data;
	} catch (err) {
		console.error(err);
		throw err;
	}
};

export const changeEmailRequest = async ({ newEmail, lang = "en" }) => {
	try {
		const response = await apiClient.post(`/user/change-email`, {
			newEmail,
			lang,
		});
		return response.data;
	} catch (err) {
		console.error(err);
		throw err;
	}
};

export const verifyEmailChange = async (token) => {
	try {
		const response = await apiClient.get(
			`${API_URL}/user/verify-email-change?token=${token}`,
		);
		return response.data;
	} catch (err) {
		console.error(err);
	}
};

export const deleteAccount = async () => {
	return apiClient.delete(`${API_URL}/user/delete-account`);
};

// Wallets API
export const getUserWallets = async () => {
	const response = await apiClient.get(`${API_URL}/wallets/userwallets`);
	return response.data;
};

export const addWallet = async ({
	name,
	type,
	currency,
	balance,
	category,
	createdAt,
}) => {
	const response = await apiClient.post(`${API_URL}/wallets`, {
		name,
		type,
		currency,
		balance,
		category,
		createdAt,
	});
	return response.data;
};

export const deleteWallet = async (walletId) => {
	const response = await apiClient.delete(`${API_URL}/wallets/${walletId}`);
	return response.data;
};

export const editWallet = async ({
	walletId,
	walletName,
	walletCategory,
	balance,
	createdAt,
}) => {
	const response = await apiClient.patch(`${API_URL}/wallets/${walletId}`, {
		walletName,
		walletCategory,
		balance,
		createdAt,
	});
	return response.data;
};

export const getWalletCategories = async () => {
	const response = await apiClient.get(`${API_URL}/wallets/categories`);
	return response.data;
};

export const getWalletValueOnDate = async ({ walletId, date }) => {
	const response = await apiClient.get(
		`${API_URL}/wallets/${walletId}/balance-on-date`,
		{ params: { date } },
	);
	return response.data;
};

// Categories API
export const getUserCategories = async () => {
	const response = await apiClient.get(`${API_URL}/categories`);
	return response.data;
};

export const addCategoryGroup = async ({ type, groupName, color }) => {
	const response = await apiClient.post(`${API_URL}/categories`, {
		type,
		groupName,
		color,
	});
	return response.data;
};

export const addSubcategory = async ({ categoryGroupId, name, emoji }) => {
	const response = await apiClient.patch(
		`${API_URL}/categories/${categoryGroupId}/subcategories`,
		{ name, emoji },
	);
	return response.data;
};

export const editCategoryGroup = async ({
	categoryGroupId,
	groupName,
	color,
}) => {
	const response = await apiClient.patch(
		`${API_URL}/categories/${categoryGroupId}`,
		{ groupName, color },
	);
	return response.data;
};

export const editSubcategory = async ({
	categoryGroupId,
	subcategoryId,
	name,
	emoji,
}) => {
	const response = await apiClient.patch(
		`${API_URL}/categories/${categoryGroupId}/subcategories/${subcategoryId}`,
		{ name, emoji },
	);
	return response.data;
};

export const deleteSubcategory = async ({
	categoryGroupId,
	subcategoryId,
	newCategoryId,
	newSubcategoryId,
}) => {
	const response = await apiClient.patch(
		`${API_URL}/categories/deleteWithReassign/${categoryGroupId}/subcategories/${subcategoryId}`,
		{ newCategoryId, newSubcategoryId },
	);
	return response.data;
};

export const deleteCategoryGroup = async ({
	categoryGroupId,
	newCategoryId,
	newSubcategoryId,
}) => {
	const response = await apiClient.patch(
		`${API_URL}/categories/deleteWithReassign/${categoryGroupId}`,
		{ newCategoryId, newSubcategoryId },
	);
	return response.data;
};

// Transactions API
export const getUserTransactions = async ({
	startDate,
	endDate,
	type,
	includeInAnalysis,
}) => {
	const response = await apiClient.get(`${API_URL}/transactions`, {
		params: { startDate, endDate, type, includeInAnalysis },
	});
	return response.data;
};

export const addCashTransaction = async ({
	walletId,
	type,
	amount,
	currency,
	categoryId,
	subcategoryId,
	description,
	createdAt,
	includeInAnalysis,
}) => {
	const response = await apiClient.post(
		`${API_URL}/transactions/add-transaction`,
		{
			walletId,
			type,
			categoryId,
			amount,
			currency,
			subcategoryId,
			description,
			createdAt,
			includeInAnalysis,
		},
	);
	return response.data;
};

export const editTransaction = async ({
	transactionId,
	description,
	amount,
	currency,
	createdAt,
	walletId,
	categoryId,
	subcategoryId,
	type,
	includeInAnalysis,
}) => {
	const response = await apiClient.put(
		`${API_URL}/transactions/edit-transaction/${transactionId}`,
		{
			description,
			amount,
			currency,
			createdAt,
			walletId,
			categoryId,
			subcategoryId,
			type,
			includeInAnalysis,
		},
	);
	return response.data;
};

export const markTransactionAsConnectedWithAssetOrLiability = async ({
	transactionId,
	investmentDebtPayoff,
}) => {
	const response = await apiClient.put(
		`${API_URL}/transactions/investment-liability/${transactionId}`,
		{ investmentDebtPayoff },
	);
	return response.data;
};

export const deleteTransaction = async (transactionId) => {
	const response = await apiClient.delete(
		`${API_URL}/transactions/delete-transaction/${transactionId}`,
	);
	return response.data;
};

export const getOldestTransactionDate = async (walletId) => {
	const response = await apiClient.get(
		`${API_URL}/transactions/oldest-transaction-date/${walletId}`,
	);
	return response.data;
};

// Currencies API
export const getAvailableCurrencies = async () => {
	const response = await apiClient.get(`${API_URL}/currencies/`);
	return response.data;
};

// Networth API
export const getNetWorth = async ({ endDate, type = "Monthly" }) => {
	const response = await apiClient.get(`${API_URL}/networth`, {
		params: { endDate, type },
	});
	return response.data;
};

export const getTodayNetWorth = async () => {
	const response = await apiClient.get(`${API_URL}/networth/today`);
	return response.data;
};

export const generateHistoricalNetWorth = async () => {
	const response = await apiClient.post(
		`${API_URL}/networth/generate-historical-networth`,
	);
	return response.data;
};

// Budgets API
export const getUserBudgets = async (period) => {
	const response = await apiClient.get(`${API_URL}/budgets`, {
		params: { period },
	});
	return response.data;
};

export const addBudget = async (budget) => {
	const {
		categoryId,
		categoryGroupId,
		walletId,
		period,
		date,
		amount,
		currency,
		type,
		totalBudget,
		recurring,
	} = budget;
	const response = await apiClient.post(`${API_URL}/budgets`, {
		categoryId,
		categoryGroupId,
		walletId,
		period,
		date,
		amount,
		currency,
		type,
		totalBudget,
		recurring,
	});
	return response.data;
};

export const editBudget = async (budget) => {
	const {
		budgetId,
		categoryId,
		categoryGroupId,
		walletId,
		period,
		date,
		amount,
		currency,
		type,
		totalBudget,
		recurring,
	} = budget;
	const response = await apiClient.put(`${API_URL}/budgets/${budgetId}`, {
		categoryId,
		categoryGroupId,
		walletId,
		period,
		date,
		amount,
		currency,
		type,
		totalBudget,
		recurring,
	});
	return response.data;
};

export const saveBudget = async (budget) => {
	if (budget.budgetId) {
		return await editBudget(budget);
	} else {
		return await addBudget(budget);
	}
};

// Cashflow API
export const getCashflow = async ({ period, periodType }) => {
	const response = await apiClient.get(`${API_URL}/cashflow`, {
		params: { period, periodType },
	});
	return response.data;
};

// Support API
export const sendSupportRequest = async ({
	topic,
	description,
	attachments = [],
}) => {
	const formData = new FormData();
	formData.append("topic", topic);
	formData.append("description", description);
	const lang = localStorage.getItem("i18nextLng") || "en";
	formData.append("lang", lang);

	attachments.forEach((file) => formData.append("attachments", file));

	const response = await apiClient.post(`${API_URL}/support`, formData);
	return response.data;
};
